import React, {
  useEffect,
  useImperativeHandle,
  forwardRef
} from 'react';
import {
  PageHeader,
  Form,
  DatePicker,
  Checkbox,
  InputNumber,
  Button,
  Space,
} from 'antd';

import moment from "moment";
import "moment/locale/fr";


const CarePlanForm = forwardRef((props, ref) => {
  let { title, subTitle, fields, carePlan, loading, careUnit } = props;
  const [form] = Form.useForm();

  const onPrevious = () => {
    if (!props.canPrevious) {
      return;
    }

    let values = form.getFieldsValue();
    props.previous(values);
  };

  const onNext = () => {
    if (!props.canNext) {
      return;
    }

    let values = form.getFieldsValue();
    props.next(values);
  };

  const onSubmit = () => {
    let values = form.getFieldsValue();
    props.submit(values);
  };

  useEffect(() => {
    form.resetFields();
  }, [props.visible]);

  useEffect(() => {
    let initialValues = {};

    fields.forEach((field, key) => {
      let name = field.key.toString();

      if (field.type === "bool") {
        initialValues[name] = false;
      } else if (field.type === "date") {
        initialValues[name] = moment();
      } else if (field.type === "int") {
        initialValues[name] = 0;
      }
    });

    initialValues['action_time'] = moment();

    if (moment() < moment().startOf('hour').hour(careUnit.care_plan_switch_hour)) {
      initialValues['action_time'] = initialValues['action_time'].subtract(1, 'days');
    }

    if (!!carePlan) {

      Object.keys(initialValues).forEach((key) => {
        let field = fields.find(item => item.key === key);

        if (carePlan.hasOwnProperty(key)) {
          let value = carePlan[key];
          if (field !== undefined && field.type === 'date') {
            value = moment(value);
          }

          initialValues[key] = value;
        }
      });
    }

    form.setFieldsValue({...initialValues});
  }, [props.fields, props.carePlan]);

  useImperativeHandle(ref, () => ({
    getValues: () => {
      return form.getFieldsValue();
    },
  }));

  if (subTitle !== null) {
    title = title + " - " + subTitle;
  }

  let formItems = fields.map((field, key) => {
    let name = field.key.toString();

    if (field.type === "bool") {
      return (
        <Form.Item
          key={key}
          name={name}
          valuePropName="checked"
          className="mb-1"
        >
          <Checkbox>{field.label}</Checkbox>
        </Form.Item>
      );
    } else if (field.type === "date") {
      return (
        <Form.Item
          key={key}
          label={field.label}
          name={name}
          className="mb-1"
        >
          <DatePicker format="DD/MM/YYYY" />
        </Form.Item>
      );
    } else if (field.type === "int") {
      return (
        <Form.Item
          key={key}
          label={field.label}
          name={name}
          className="my-2"
        >
          <InputNumber min={field.min} max={field.max} />
        </Form.Item>
      );
    }
  });

  return (
    <>
      <div className="mb-3">
        <PageHeader ghost={false} title={title} className="pt-0" />
        <Form
          form={form}
          name="care_plan"
        >
          {formItems}
        </Form>
      </div>

      <Space style={{ position: 'absolute', bottom: 10 }}>
        <Button
          onClick={() => onPrevious()}
          disabled={!props.canPrevious}
        >
          Précedent
        </Button>
      </Space>
      <Space
        style={{
          position: 'absolute',
          bottom: 10,
          right: 10
        }}
      >
        <Button
          onClick={() => onNext()}
          disabled={!props.canNext}
        >
          Suivant
        </Button>
        <Button
          type="primary"
          loading={loading}
          onClick={() => onSubmit()}
        >
          Valider
        </Button>
      </Space>
    </>
  );
});

export default CarePlanForm;